import useAnchorClickMessageDispatcher from '@carvana/merch-native/useAnchorClickMessageDispatcher';
import { useEffect } from 'react';
import useMicroFrontend from '~/components/common/MicroFrontEnds';
import { isNonProd } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import ErrorWithContext from '~/utilities/ErrorWithContext';
import { logError } from '~/utilities/loggers';

/**
 * Shared functionality for app router error pages.
 * Requires an AnalyticsProvider ancestor in the layout tree — without one,
 * trackEvent is a no-op and the oopsPageError event is silently dropped.
 */
export default function useErrorPage(
  page: string,
  error?: Error & { digest?: string }
) {
  const trackEvent = useTrackEvent();

  useMicroFrontend(false);

  useAnchorClickMessageDispatcher({
    logError,
    source: 'error-page',
    verboseLogs: isNonProd
  });

  useEffect(() => {
    logError(
      new ErrorWithContext(error, {
        digest: error?.digest,
        location: `${page} App Router Error Boundary`
      })
    );
  }, [error, page]);

  useEffect(() => {
    trackEvent('oopsPageError', {
      digest: error?.digest,
      error: error?.message,
      page
    });
  }, [error, page, trackEvent]);
}
